import { useIonToast } from '@ionic/react';
import React, { useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import { useWP } from '../../hooks/WPHooks';
import { EntryUpdate, WP_Form } from '../../model/models';
import { AppContext } from '../../state/AppContextProvider';
import { Input } from './Input';

interface FormsProps {
  postId: number;
  form: WP_Form;
}

export const Form: React.FC<FormsProps> = ({ postId, form }) => {
  const { state } = useContext(AppContext);
  const [present] = useIonToast();
  const intl = useIntl();
  const { wp } = useWP();

  const [disabled, setDisabled] = useState(false);

  const [showButton, setShowButton] = useState(true);

  const [fields, setFields] = useState({});

  const resetForm = () => {
    setDisabled(false);
    setShowButton(true);
    setFields({});
  };

  const handleFieldChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    // create a copy of actual values
    const newFields = Object.assign({}, fields);

    // update with new value
    newFields[name] = value;

    // update state
    setFields(newFields);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // disable the form
    setDisabled(true);

    const data: EntryUpdate = {
      status: 'publish',
      title:
        form.form_title +
        ' : ' +
        event.target.entry_first_name.value +
        ' ' +
        event.target.entry_name.value,
      acf: {
        entry_id_post: postId,
        entry_service_email: form.form_email_receiver,
        entry_datas: [
          {
            entries_datas_key: 'first_name',
            entries_datas_value: event.target.entry_first_name.value
              ? event.target.entry_first_name.value
              : null,
          },
          {
            entries_datas_key: 'last_name',
            entries_datas_value: event.target.entry_name.value
              ? event.target.entry_name.value
              : null,
          },
          {
            entries_datas_key: 'sender_email',
            entries_datas_value: event.target.entry_sender_email.value
              ? event.target.entry_sender_email.value
              : null,
          },
          {
            entries_datas_key: 'object',
            entries_datas_value: event.target.entry_object.value
              ? event.target.entry_object.value
              : null,
          },
          {
            entries_datas_key: 'content',
            entries_datas_value: event.target.entry_content.value
              ? event.target.entry_content.value
              : null,
          },
        ],
        entry_status: 'not_sent',
      },
    };

    await wp
      .postEntry(state.locale, data)
      .then(() => {
        // keep the form disabled
        // hide submit button
        setDisabled(false);
        resetForm();
        present({
          color: 'primary',
          position: 'top',
          message: intl.formatMessage({
            id: 'Form Submited',
          }),
          duration: 2000,
        });
      })
      .catch(() => {
        // enable the form
        setDisabled(false);
        present({
          color: 'dark',
          position: 'top',
          message: intl.formatMessage({
            id: 'Form Not Submited',
          }),
          duration: 2000,
        });
      });
  };

  const form_not_empty =
    form !== undefined
      ? form?.form_activation !== false
        ? form
        : false
      : false;

  return form_not_empty ? (
    <div className="bg-white rounded-3xl py-10 px-5 -mt-7 md:-mt-0">
      <h2 className="font-bold text-lg text-center mb-4">{form.form_title}</h2>
      <form
        className="flex flex-col items-center justify-center"
        onSubmit={handleSubmit}
      >
        <Input
          className="hidden"
          name="entry_first_name"
          type="text"
          value={state.user?.first_name}
          disabled={disabled}
        />
        <Input
          className="hidden"
          name="entry_name"
          type="text"
          value={state.user?.last_name}
          disabled={disabled}
        />
        <Input
          className="hidden"
          name="entry_sender_email"
          type="text"
          value={state.user?.email}
          disabled={disabled}
        />
        <Input
          className=""
          label="Object"
          name="entry_object"
          type="text"
          placeholder={intl.formatMessage({
            id: 'Enter the object',
          })}
          disabled={disabled}
          value={fields['entry_object'] || ''}
          onChange={handleFieldChange}
        />
        <Input
          className=""
          label="Content"
          name="entry_content"
          type="textarea"
          placeholder={intl.formatMessage({
            id: 'Enter your request here',
          })}
          disabled={disabled}
          value={fields['entry_content'] || ''}
          onChange={handleFieldChange}
        />
        <Input
          className={showButton ? '' : 'hidden'}
          type="submit"
          value="Envoyer"
          disabled={disabled}
        />
      </form>
    </div>
  ) : (
    <></>
  );
};

export default Form;
